import React, { FC } from 'react';

import { Grid, Stack } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  AmazonSideASN,
  AutoAcceptSharedAttachments,
  DefaultRouteTableAssociation,
  DefaultRouteTableID,
  DefaultRouteTablePropagation,
  DNSSupport,
  VPNECMPSupport,
} from '../../../../Components/MetadataField/MetaGridFields';

export const TransitGatewayMetadata: FC = () => {
  const { resourceDetails } = useActiveResourceContext();
  const { data: resource } = resourceDetails;

  return (
    <Stack spacing={6}>
      <Grid templateColumns="repeat(4, 1fr)" gap={4}>
        <MetadataCommonFields createdAtTime="utc" />
        {AmazonSideASN(resource)}
        {AutoAcceptSharedAttachments(resource)}
        {DefaultRouteTableAssociation(resource)}
        {DefaultRouteTableID(resource)}
        {DefaultRouteTablePropagation(resource)}
        {VPNECMPSupport(resource)}
        {DNSSupport(resource)}
      </Grid>
    </Stack>
  );
};
